const CHANNEL_NAME = 'advertiser-portal-pwa-emulation-channel';

const isBrowser = typeof window !== 'undefined' && typeof window.BroadcastChannel !== 'undefined';

export const channel = isBrowser ? new BroadcastChannel(CHANNEL_NAME) : null;

export type BroadcastMessage = {
  type: 'EMULATION_EVENT';
  ts: number;
  origin: string;
  reloadTimeout: number;
};

export const tabId = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2);

// send
export function broadcastEmulationTrigger(reloadTimeout: number) {
  channel.postMessage({
    type: 'EMULATION_EVENT',
    ts: Date.now(),
    origin: tabId,
    reloadTimeout,
  });
}
